import { useCallback, useEffect } from 'react';
import { GlobalState, Selection } from '@leverege/ui-redux';
import { History } from '@leverege/molten-core';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
export default function useThumbnailSelection(opts) {
  const {
    selectionKey,
    delegate
  } = opts;
  const selected = useSelector(state => Selection.get(state, selectionKey));
  const location = useLocation();
  const selectedItem = selected?.items?.[0];
  const setSelection = useCallback(item => {
    if (item?.data?.path) {
      const search = new URLSearchParams(location.search);
      if (item.data.path !== search.get('selectedItem')) {
        search.set('selectedItem', item.data.path);
        GlobalState.dispatch(History.push({
          search: search.toString()
        }));
      }
    } else {
      const search = new URLSearchParams(location.search);
      search.delete('selectedItem');
      GlobalState.dispatch(History.push({
        search: search.toString()
      }));
    }
  }, [location]);
  const loadData = useCallback(async selectedItem => {
    if (selectedItem) {
      let item = delegate.item(selectedItem).getItem();
      if (!item) {
        item = await GlobalState.dispatch(delegate.item(selectedItem).get());
      }
      if (item) {
        item = delegate.toObjectRef(item);
      }
      return item;
    }
    return null;
  }, [delegate]);
  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const selectedItem = search.get('selectedItem');
    loadData(selectedItem).then(item => {
      if (item) {
        GlobalState.dispatch(Selection.set(selectionKey, [item]));
      } else {
        GlobalState.dispatch(Selection.clear(selectionKey));
      }
    });
  }, [location.search, loadData, selectionKey]);
  const onSelect = useCallback(evt => {
    const selected = evt.data;
    setSelection(selected);
  }, [setSelection]);
  const onClose = useCallback(() => {
    setSelection();
  }, [setSelection]);
  return {
    onSelect,
    onClose,
    selectedItem
  };
}